import { CaseListElement, FilterInterface } from '@dandelion/core';
import { Ref } from 'vue';

export abstract class BaseFilter<T> implements FilterInterface {
  constructor(
    protected key: string,
    protected valueOfFilter: Ref<T>,
    private comparator: (a: T, b: T) => boolean
  ) {
  }
  apply(caseListElement: CaseListElement): boolean {
    const filterValue = this.valueOfFilter.value
    if (!filterValue) {
      return true;
    }
    const cacheValue = caseListElement.cache.get(this.key);
    if (cacheValue === undefined || cacheValue === "") {
      return false;
    }
    return this.comparator(cacheValue as T, filterValue);
  }

  isActive(): boolean {
    return !!this.valueOfFilter.value;
  }
}

export class StringFilter extends BaseFilter<string> {
  constructor(key: string, valueOfFilter: Ref<string>) {
    super(key, valueOfFilter, (cacheValue, filterValue) =>
      cacheValue.toLowerCase().includes(filterValue.toLowerCase())
    );
  }
}

export class NumberFilter implements FilterInterface {
  constructor(
    private key: string,
    private valueOfFilter: Ref<number>,
  ) {
  }

  apply(value: CaseListElement): boolean {
    const filterValue = this.valueOfFilter.value;
    const cacheValue = value.cache.get(`core.${this.key}`);
    if (filterValue === undefined || filterValue === null) {
      return true;
    }
    if (cacheValue === undefined) {
      return false;
    }
    return cacheValue.toString() == filterValue.toString();
  }

  isActive(): boolean {
        const v = this.valueOfFilter.value;
  return v !== null && v !== undefined;
  }
}

export class DateFilter implements FilterInterface {
  constructor(
    private key: string,
    private startValueOfFilter: Ref<Date>,
    private endValueOfFilter : Ref<Date>
  ) {
  }

  apply(value: CaseListElement): boolean {
    const cacheValue = value.cache.get(`core.${this.key}`);
    if (this.startValueOfFilter.value === undefined || this.startValueOfFilter.value === null) {
      return true;
    }
    if (cacheValue === undefined) {
      return false;
    }
    if (this.endValueOfFilter.value === undefined || this.endValueOfFilter.value === null)
    return cacheValue.toString() == this.startValueOfFilter.value.toString();
  else
  return (
    new Date(this.startValueOfFilter.value) <= new Date(cacheValue) &&
    new Date(cacheValue) <= new Date(this.endValueOfFilter.value)
  );

  }

  isActive(): boolean {
    return !!this.startValueOfFilter.value;
  }
}
export class MinDateFilter extends BaseFilter<Date> {
  constructor(key: string, valueOfFilter: Ref<Date>) {
    super(key, valueOfFilter, (a, b) => a >= b);
  }
}

export class MaxDateFilter extends BaseFilter<Date> {
  constructor(key: string, valueOfFilter: Ref<Date>) {
    super(key, valueOfFilter, (a, b) => a <= b);
  }
}

export class StatusFilter implements FilterInterface {
  constructor(
    private key: string,
    private valueOfFilter: Ref<number>,
  ) {
  }

  apply(value: CaseListElement): boolean {
    const filterValue = this.valueOfFilter.value;
    const statusMap = value.caseMetaData.status.get("*");
    const statusValue = statusMap.get(this.key);
    if (filterValue === undefined || filterValue === null) {
        return true;
    }
    return statusValue === filterValue;
  }
  isActive(): boolean {
        const v = this.valueOfFilter.value;
  return v !== null && v !== undefined;
  }
}

export class AuthorizationFilter implements FilterInterface {
  constructor(
    private key: string,
    private valueOfFilter: Ref<string>,
  ) { }

  apply(value: CaseListElement): boolean {
    const filterType = this.valueOfFilter.value;
    if (filterType === undefined || filterType === null) {
      return true;
  }
    switch (filterType) {
      case 'signed':
        return value.cache.get('consent') === 'yes';
      case 'notSigned':
        return value.cache.get('consent') === 'no';
      case 'eximent':
        return value.cache.get('consent') === 'eximent';
      case 'notNecessary':
        return value.cache.get('consentNotNecessary') === true;
      default:
        return false;
    }
  }

  isActive(): boolean {
    return !!this.valueOfFilter.value;
  }
}

export class FilterOnlyPatientsWithConsent implements FilterInterface {
  constructor() {
  }

  apply(value: CaseListElement): boolean {
    return (value.cache.get('consentSigned') === undefined && value.cache.get('consentNotNecessary') === undefined)
      || value.cache.get('consentSigned') === true
      || value.cache.get('consentNotNecessary') === true;
  }

  isActive(): boolean {
    return true;
  }
}

export class RealTestCasesFilter implements FilterInterface {
  constructor(
    private key: string,
    private valueOfFilter: Ref<string>,
  ) {
  }

  apply(value: CaseListElement): boolean {
    const filterValue = this.valueOfFilter.value !== 'false';
    const valueOfCase = value.cache.get('caseIsTest') === true;
    if (filterValue === undefined || filterValue === null) {
      return true;
    }
    return valueOfCase !== filterValue;
  }

  isActive(): boolean {
    return !!this.valueOfFilter.value;
  }
}
